export default __webpack_public_path__ + "static/cms-c5eaca8207373d8ba6ca178b1471dc01.png";